// base
import React, { createContext, useContext, useState, useCallback } from 'react';

// components
import { AlertModal } from 'components';

const AlertContext = createContext({
  showAlert: () => {},
  hideAlert: () => {}
});

export const AlertProvider = ({ children }) => {
  const [closeCallback, setCloseCallback] = useState();
  const [alertProps, setAlertProps] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [isSingleBtn, setIsSingleBtn] = useState(false);

  const showAlert = useCallback((props) => {
    const { message, isSingleBtn = false, onClose = () => {}, alertProps = {} } = props;

    setAlertMessage(message);
    setCloseCallback(onClose);
    setIsOpen(true);
    setIsSingleBtn(isSingleBtn);
    setAlertProps(alertProps);
  }, []);

  const hideAlert = useCallback(() => {
    setIsOpen(false);
    setAlertMessage('');

    if (closeCallback) {
      closeCallback?.();
      setCloseCallback(undefined);
    }
  }, [closeCallback]);

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert }}>
      <AlertModal
        onOk={hideAlert}
        onClose={hideAlert}

        open={isOpen}
        isSingleBtn={isSingleBtn}
        {...alertProps}
      >
        {alertMessage}
      </AlertModal>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);

  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }

  return {
    ...context
  };
};
